import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Loading } from "./States";

/** Gate the ticket routes. While the cookie probe is in flight we show a spinner;
 *  once resolved, anonymous users are bounced to /signin (preserving the intended
 *  destination so /verify can return them here). */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") return <Loading label="Checking your session…" />;
  if (status === "anonymous") {
    return (
      <Navigate to="/signin" replace state={{ from: location.pathname + location.search }} />
    );
  }
  return <>{children}</>;
}
